import type { SearchForm } from '@shared/typings/search';
import { LSK } from '@shared/utils/storage/config';

export const getSearchParams: () =>
	| { search_content: string; location: string; search_method: SearchForm }
	| object = () => {
	const isSearchPage = window.location.pathname.includes('/search');

	return isSearchPage
		? {
				search_content: localStorage.getItem(LSK.SEARCH_KEYWORD) || '',
				search_method: localStorage.getItem(LSK.SEARCH_METHOD) || '',
				location: 'search_result',
			}
		: {};
};

/** 获取当前选择的标签ID，通过URL，适用于曝光 */
export const getTagId = (location: string) => {
	const isSearchPage = window.location.pathname.includes('/search');
	const labelId = new URLSearchParams(window.location.search).get('labelId');

	if (labelId) return labelId;
	if (location === 'discover' || location === 'feed') return 'All';
	if (isSearchPage) return 'search';
	return 'none';
};
